import { Double } from '@/components/templates/Double/templates/Double'
import { memo } from 'react'

const DoublePage = () => {
  return <Double />
}

export default memo(DoublePage)
